exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".au-btn-holder{justify-content:center}.wwd-container{margin:64px 0}.au-our-team-container{align-items:center;margin:64px 0}.au-members-container,.au-our-team-container{display:flex;flex-direction:column}.au-member-container{margin:30px 0}.au-member-avatar-wrapper,.au-member-container{display:flex;align-items:center}.au-member-avatar{max-width:200px}.au-info-wrapper{flex:1;margin-left:30px;flex-direction:column;justify-content:space-between}.au-member-name{font-size:24px;font-weight:600;color:#069ee5}.au-member-role{font-style:italic;margin-bottom:8px}.au-member-description,.au-member-role{font-size:16px;line-height:1.5;color:#fff}.au-member-description{margin:8px 0;text-align:justify}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/components/informations/aboutUs/styles.css
// module id = 981
// module chunks = 0